import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import * as galleryReducers from "../../reducers/gallery";
import * as galleryActions from "../../actions/gallery";
import {withRouter} from 'react-router';

import NewItem from '../common/NewItem';
import GraphicItem from './GraphicItem';
import FilterBar from "../common/FilterBar";
import Slider from "../includes/Slider/index";
import Loader from 'react-loader-spinner';
class GraphicsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            imagesList :[],
            modal: false,
            iname_class : '',
            itags_class : '',
            image_name: '',
            image_tags: '',
            image_path: '',
            redirect: false,
            userDet : JSON.parse(window.localStorage.userDet)
        };


    }


    componentDidMount() {

        console.log(this.props.galleryInfo.gal_type);
        let data = {"gal_type" : this.props.galleryInfo.gal_type, userid : this.state.userDet.user_id};
        this.props.allGalleryData(data);
        let wrap_class = 'gallery-wrapper ';

        switch(this.props.galleryInfo.gal_type) {
            case 'MY_UPLOADS' : wrap_class += ' image-float';
                                break;

            case 'AUDIO' : wrap_class += ' voice-float';
                                break;
            case 'VIDEO' : wrap_class += ' video-float';
                                break;
            default : wrap_class += ' image-float';
                break;

        }

        this.setState({ wrap_class : wrap_class });
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.galleryInfo.galleryCreated !== prevProps.galleryInfo.galleryCreated ) {
            this.forceUpdateHandler();
        }
    }

    forceUpdateHandler(){
        let data = {"gal_type" : this.props.galleryInfo.gal_type, userid : this.state.userDet.user_id};
        this.props.allGalleryData(data);
    }

    renderSlider(galList) {

        return (
            <div>
            { galList &&
            <Slider galItems={galList}/>
            }
            </div>
        );
    }

    render() {

    	const { redirect } = this.state;

        if (redirect) {
            return <Redirect to='/builder'/>;
        }

        let galleryList = this.props.galleryData.galleryItems;

        console.log(galleryList);

        return (

            <div className={this.state.wrap_class} >

                {!galleryList &&
                <div className="loaderWrapper">
                    <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                </div>
                }
                <NewItem item_type={this.props.galleryInfo.gal_type}/>

                { galleryList  &&


                    galleryList.map((entry, index) => <GraphicItem detail={entry} galIndex={index} />

                        )
                }
                { this.props.galleryInfo.gal_type !== 'AUDIO' ? this.renderSlider(galleryList):null }
            </div>


        );
    }
}


GraphicsContainer.propTypes = {
    gal_type: PropTypes.string
}


function mapStateToProps(state) {
    return {
        galleryData  :galleryReducers.getGalleryData(state),
        galleryInfo  :galleryReducers.setGalleryUpdate(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    allGalleryData : galleryActions.galleryData
})(GraphicsContainer, FilterBar));




// WEBPACK FOOTER //
// ./src/components/gallery/GraphicsContainer.js